import Vue from 'vue'
import Router from 'vue-router'
import _ from 'lodash'
import store from '@/store'
import * as define from '@/define'

import DashBoard from '@/components/pages/dashboard/DashBoardTop'
import DashBoardDemo from '@/components/pages/dashboard/DashBoardTopDemo'
import OrderList from '@/components/pages/order/OrderListTop'
import ExtraExportList from '@/components/pages/order/ExtraExportListTop'
import OrderDetail from '@/components/pages/order/OrderDetailTop'
import CustomerList from '@/components/pages/customer/CustomerListTop'
import CustomerDetail from '@/components/pages/customer/CustomerDetailTop'
import PointList from '@/components/pages/customer/PointListTop'
import AccountList from '@/components/pages/account/AccountListTop'
import AccountDetail from '@/components/pages/account/AccountDetailTop'
import ChangePassword from '@/components/pages/account/ChangePassword'
import SiteRoleList from '@/components/pages/account/SiteRoleListTop'
import SiteRoleDetail from '@/components/pages/account/SiteRoleDetailTop'
import PermissionRoleList from '@/components/pages/account/PermissionRoleListTop'
import PermissionRoleDetail from '@/components/pages/account/PermissionRoleDetailTop'
import PointBasicSetting from '@/components/pages/point/PointBasicSettingTop'
import CustomerRank from '@/components/pages/point/CustomerRankTop'
import CustomerRankDetail from '@/components/pages/point/CustomerRankDetailTop'
import PointSetting from '@/components/pages/point/PointSettingTop'
import PointSettingDetail from '@/components/pages/point/PointSettingDetailTop'
import Download from '@/components/pages/upload_download/download/DownloadTop'
import Upload from '@/components/pages/upload_download/upload/UploadTop'
import Log from '@/components/pages/system/LogTop'
import Batch from '@/components/pages/system/BatchTop'
import Login from '@/components/pages/login/LoginTop'

// import ProductList from '@/components/pages/product/sasage/ProductListTop'
// import ProductDetail from '@/components/pages/product/sasage/ProductDetailTop'

import ProductMasterList from '@/components/pages/product/ProductListTop'
import ProductOrderQuantity from '@/components/pages/product/ProductOrderQuantityListTop'
import ProductMasterDetail from '@/components/pages/product/ProductDetailTop'
import MasterColor from '@/components/pages/product/master/MasterColorTop'
import MasterColorGroup from '@/components/pages/product/master/MasterColorGroupTop'
import MasterSize from '@/components/pages/product/master/MasterSizeTop'
import MasterSizeGroup from '@/components/pages/product/master/MasterSizeGroupTop'

import MasterLogisticsCalendar from '@/components/pages/ship/MasterLogisticsCalendarTop'
import PendingProductList from '@/components/pages/settings/PendingProductListTop'

import EcStockList from '@/components/pages/stock/EcStockListTop'
import StockAlertList from '@/components/pages/stock/StockAlertListTop'
import StockAlertDetail from '@/components/pages/stock/StockAlertDetailTop'
import StockAdjustmentList from '@/components/pages/stock/StockAdjustmentListTop'
import StockMoveInstructList from '@/components/pages/stock/StockMoveInstructListTop'
import StockDestination from '@/components/pages/stock/StockDestination'

import MailTemplateList from '@/components/pages/mail/MailTemplateListTop'

// SMS PJ
import PaymentList from '@/components/pages/report/payment/PaymentCreditListTop'
import PaymentConvenienceList from '@/components/pages/report/payment/PaymentConvenienceListTop'
import PaymentCarrierList from '@/components/pages/report/payment/PaymentCarrierListTop'
import PaymentIdList from '@/components/pages/report/payment/PaymentIdListTop'
import SalesPhysicalList from '@/components/pages/report/sales/SalesPhysicalListTop'
import SalesDigitalList from '@/components/pages/report/sales/SalesDigitalListTop'
import SalesProductPhysicalList from '@/components/pages/report/sales/SalesProductPhysicalListTop'
import SalesProductDigitalList from '@/components/pages/report/sales/SalesProductDigitalListTop'
import SalesYellDigitalList from '@/components/pages/report/sales/SalesYellDigitalListTop'

// debug
import ValidationExample from '@/components/pages/dashboard/ValidationExample'
import ForTest from '@/components/pages/dashboard/forTest'
import item from '@/components/pages/dashboard/item'

import auth from '@/utils/auth'
import * as config from '@/config'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/item',
      name: 'item',
      component: item
    },
    {
      path: '/forTest',
      name: 'forTest',
      component: ForTest
    },
    {
      path: '/validation',
      name: 'validation',
      component: ValidationExample
    },
    {
      path: '*',
      name: 'NoName',
      redirect: { name: 'DashBoard' }
    },
    {
      path: '/dashboard',
      name: 'DashBoard',
      component: config.IS_DEMO_MODE ? DashBoardDemo : DashBoard,
      meta: {
        title: 'ダッシュボード'
      }
    },
    {
      path: '/order',
      name: 'OrderList',
      component: OrderList,
      meta: {
        title: '注文一覧',
        funcId: define.PermissionKeys.Order.LIST
      }
    },
    {
      path: '/extraExport',
      name: 'ExtraExportList',
      component: ExtraExportList,
      meta: {
        title: '臨時出荷依頼一覧',
        funcId: define.PermissionKeys.Order.EXTRA_EXPORT_LIST
      }
    },
    {
      path: '/order/:id',
      name: 'OrderDetail',
      component: OrderDetail,
      meta: {
        title: '注文詳細',
        funcId: define.PermissionKeys.Order.DETAIL
      }
    },
    {
      path: '/customer',
      name: 'CustomerList',
      component: CustomerList,
      meta: {
        title: '顧客一覧',
        funcId: define.PermissionKeys.Customer.LIST
      }
    },
    {
      path: '/customer/:id',
      name: 'CustomerDetail',
      component: CustomerDetail,
      meta: {
        title: '顧客詳細',
        funcId: define.PermissionKeys.Customer.DETAIL
      }
    },
    {
      path: '/point',
      name: 'PointList',
      component: PointList,
      meta: {
        title: 'ポイント一覧',
        funcId: 'point_history_list'
      }
    },
    {
      path: '/account',
      name: 'AccountList',
      component: AccountList,
      meta: {
        title: 'アカウント一覧',
        funcId: define.PermissionKeys.Account.Account.LIST
      }
    },
    {
      path: '/account/:id',
      name: 'AccountDetail',
      component: AccountDetail,
      meta: {
        title: 'アカウント詳細',
        funcId: define.PermissionKeys.Account.Account.DETAIL
      }
    },
    {
      path: '/password',
      name: 'ChangePassword',
      component: ChangePassword,
      meta: {
        title: 'パスワード'
      }
    },
    {
      path: '/siterole',
      name: 'SiteRoleList',
      component: SiteRoleList,
      meta: {
        title: 'サイトロール一覧',
        funcId: define.PermissionKeys.Account.SiteRole.LIST
      }
    },
    {
      path: '/siterole/:id',
      name: 'SiteRole',
      component: SiteRoleDetail,
      meta: {
        title: 'サイトロール詳細',
        funcId: define.PermissionKeys.Account.SiteRole.DETAIL
      }
    },
    {
      path: '/permissionrole',
      name: 'PermissionRoleList',
      component: PermissionRoleList,
      meta: {
        title: '権限ロール一覧',
        funcId: define.PermissionKeys.Account.PermissionRole.LIST
      }
    },
    {
      path: '/permissionrole/:id',
      name: 'PermissionRole',
      component: PermissionRoleDetail,
      meta: {
        title: '権限ロール詳細',
        funcId: define.PermissionKeys.Account.PermissionRole.DETAIL
      }
    },
    {
      path: '/pointsetting',
      name: 'PointSetting',
      component: PointSetting,
      meta: {
        title: 'ポイント設定',
        funcId: 'pointSetting_list'
      }
    },
    {
      path: '/pointsetting/:id',
      name: 'PointSettingDetail',
      component: PointSettingDetail,
      meta: {
        title: 'ポイント設定詳細',
        funcId: 'pointSetting_detail'
      }
    },
    {
      path: '/pointbasicsetting',
      name: 'PointBasicSetting',
      component: PointBasicSetting,
      meta: {
        title: 'ポイント基本設定',
        funcId: 'pointBasicSetting_detail'
      }
    },
    {
      path: '/customerrank',
      name: 'CustomerRank',
      component: CustomerRank,
      meta: {
        title: '',
        funcId: 'customerRank_list'
      }
    },
    {
      path: '/customerrank/:id',
      name: 'CustomerRankDetail',
      component: CustomerRankDetail,
      meta: {
        title: '顧客ランク詳細',
        funcId: 'customerRank_detail'
      }
    },
    {
      path: '/download',
      name: 'Download',
      component: Download,
      meta: {
        title: 'ダウンロード',
        funcId: define.PermissionKeys.FileIo.DOWNLOAD
      }
    },
    {
      path: '/upload',
      name: 'Upload',
      component: Upload,
      meta: {
        title: 'アップロード',
        funcId: define.PermissionKeys.FileIo.UPLOAD
      }
    },
    {
      path: '/log',
      name: 'Log',
      component: Log,
      meta: {
        title: 'ログ一覧',
        funcId: 'log'
      }
    },
    {
      path: '/batch',
      name: 'Batch',
      component: Batch,
      meta: {
        title: 'バッチ一覧',
        funcId: 'batch'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        notRequiresAuth: true
      }
    },
    {
      path: '/login/acn',
      name: 'Login',
      component: Login,
      meta: {
        notRequiresAuth: true
      }
    },
    // {
    //   path: '/product',
    //   name: 'ProductList',
    //   component: ProductList,
    //   meta: {
    //     title: '商品一覧',
    //     funcId: 'sasage_list'
    //   }
    // },
    // {
    //   path: '/product/:id',
    //   name: 'ProductDetail',
    //   component: ProductDetail,
    //   meta: {
    //     title: '商品詳細',
    //     funcId: 'sasage_detail'
    //   }
    // },
    {
      path: '/product',
      name: 'ProductMasterList',
      component: ProductMasterList,
      meta: {
        title: '商品一覧',
        funcId: 'product_list'
      }
    },
    {
      path: '/orderQuantity',
      name: 'ProductOrderQuantity',
      component: ProductOrderQuantity,
      meta: {
        title: '受注数一覧',
        funcId: 'product_order_quantity_list'
      }
    },
    {
      path: '/product/:id',
      name: 'ProductMasterDetail',
      component: ProductMasterDetail,
      meta: {
        title: '商品詳細',
        funcId: 'product_detail'
      }
    },
    {
      path: '/master/color',
      name: 'MasterColor',
      component: MasterColor,
      meta: {
        title: 'カラーマスタ',
        funcId: 'master_color_list'
      }
    },
    {
      path: '/master/colorGroup',
      name: 'MasterColorGroup',
      component: MasterColorGroup,
      meta: {
        title: 'カラーグループマスタ',
        funcId: 'master_color_group_list'
      }
    },
    {
      path: '/master/size',
      name: 'MasterSize',
      component: MasterSize,
      meta: {
        title: 'サイズマスタ',
        funcId: 'master_size_list'
      }
    },
    {
      path: '/master/sizeGroup',
      name: 'MasterSizeGroup',
      component: MasterSizeGroup,
      meta: {
        title: 'サイズグループマスタ',
        funcId: 'master_size_group_list'
      }
    },
    {
      path: '/ship',
      name: 'MasterLogisticsCalendar',
      component: MasterLogisticsCalendar,
      meta: {
        title: '物流カレンダーメンテナンス',
        funcId: 'master_ship_holiday_list'
      }
    },
    {
      path: '/ecStock',
      name: 'EcStockList',
      component: EcStockList,
      meta: {
        title: 'EC在庫一覧',
        funcId: define.PermissionKeys.Stock.EcStock.LIST
      }
    },
    {
      path: '/stockAlert',
      name: 'StockAlertList',
      component: StockAlertList,
      meta: {
        title: 'EC在庫アラート設定一覧',
        funcId: define.PermissionKeys.Stock.Alert.LIST
      }
    },
    {
      path: '/stockAlert/:id',
      name: 'StockAlertDetail',
      component: StockAlertDetail,
      meta: {
        title: 'EC在庫アラート設定詳細',
        funcId: define.PermissionKeys.Stock.Alert.DETAIL
      }
    },
    {
      path: '/stockAdjustment',
      name: 'StockAdjustmentList',
      component: StockAdjustmentList,
      meta: {
        title: '在庫調整指示一覧',
        funcId: define.PermissionKeys.Stock.Adjustment.LIST
      }
    },
    {
      path: '/stockMove',
      name: 'StockMoveInstructList',
      component: StockMoveInstructList,
      meta: {
        title: '在庫移動指示一覧',
        funcId: define.PermissionKeys.Stock.Move.LIST
      }
    },
    {
      path: '/destination',
      name: 'StockDestination',
      component: StockDestination,
      meta: {
        title: '出荷先マスタ',
        funcId: define.PermissionKeys.Stock.Destination.LIST
      }
    },
    {
      path: '/settings/mailTemplate',
      name: 'MailTemplateList',
      component: MailTemplateList,
      meta: {
        title: '各種設定',
        funcId: define.PermissionKeys.SETTINGS
      }
    },
    {
      path: '/settings/pendingProduct',
      name: 'PendingProductList',
      component: PendingProductList,
      meta: {
        title: '各種設定',
        funcId: define.PermissionKeys.SETTINGS
      }
    },
    {
      path: '/report/payment/credit',
      name: 'PaymentList',
      component: PaymentList,
      meta: {
        title: '決済ログ:クレジットカード',
        funcId: define.PermissionKeys.Report.Payment.PAYMENT
      }
    },
    {
      path: '/report/payment/convenience',
      name: 'PaymentConvenienceList',
      component: PaymentConvenienceList,
      meta: {
        title: '決済ログ:コンビニ',
        funcId: define.PermissionKeys.Report.Payment.PAYMENT
      }
    },
    {
      path: '/report/payment/carrier',
      name: 'PaymentCarrierList',
      component: PaymentCarrierList,
      meta: {
        title: '決済ログ:d払い',
        funcId: define.PermissionKeys.Report.Payment.PAYMENT
      }
    },
    {
      path: '/report/payment/id',
      name: 'PaymentIdList',
      component: PaymentIdList,
      meta: {
        title: '決済ログ:PayPay',
        funcId: define.PermissionKeys.Report.Payment.PAYMENT
      }
    },
    {
      path: '/report/sales/physical',
      name: 'SalesPhysicalList',
      component: SalesPhysicalList,
      meta: {
        title: '販売売上レポート(フィジカル):期間分析',
        funcId: define.PermissionKeys.Report.Sales.SALES_LIST
      }
    },
    {
      path: '/report/sales/digital',
      name: 'SalesDigitalList',
      component: SalesDigitalList,
      meta: {
        title: '販売売上レポート(デジタル):期間分析',
        funcId: define.PermissionKeys.Report.Sales.SALES_LIST
      }
    },
    {
      path: '/report/sales/product/physical',
      name: 'SalesProductPhysicalList',
      component: SalesProductPhysicalList,
      meta: {
        title: '販売売上レポート(フィジカル):期間分析（商品別）',
        funcId: define.PermissionKeys.Report.Sales.SALES_PRODUCT_LIST
      }
    },
    {
      path: '/report/sales/product/digital',
      name: 'SalesProductDigitalList',
      component: SalesProductDigitalList,
      meta: {
        title: '販売売上レポート(デジタル):期間分析（商品別）',
        funcId: define.PermissionKeys.Report.Sales.SALES_PRODUCT_LIST
      }
    },
    {
      path: '/report/sales/yell/digital',
      name: 'SalesYellDigitalList',
      component: SalesYellDigitalList,
      meta: {
        title: '販売売上レポート(デジタル):期間分析（エール別）',
        funcId: define.PermissionKeys.Report.Sales.SALES_YELL_LIST
      }
    }
  ]
})

/**
 * ルート変更時のチェックを行います。
 */
router.beforeEach(async (to, from, next) => {
  try {
    // ログインチェック
    if (to.matched.some(record => !record.meta.notRequiresAuth) && !store.state.loggedIn) {
      next({
        path: '/login', query: { redirect: to.fullPath }
      })
    } else {
      // 権限チェック
      if (!Vue.prototype.$isFunctionShown(to.meta.funcId) || Vue.prototype.$isFunctionDisabled(to.meta.funcId)) {
        next({
          path: from.path === '/login' ? '/dashboard' : from.fullPath
        })
      } else {
        // ログイン状態の場合は トークンチェックを行う
        if (store.state.loggedIn) {
          await auth.tokenExpiredTransitionLogin(to.fullPath)
        }
        if (to.name !== 'NoName') {
          const activeNaviIndex = _.chain(to.params)
            .keys()
            .map((val) => `/:${val}`)
            .join('|')
            .thru((val) => {
              return _.replace(to.matched[0].path, val, '')
            })
            .value()
          store.dispatch({ type: 'set', states: { 'activeNaviIndex': activeNaviIndex } })
        } else {
          store.dispatch({ type: 'set', states: { 'activeNaviIndex': '/dashboard' } })
        }
        next()
      }
    }
  } catch (error) {
    Vue.prototype.$notify.error({ error: error })
    throw error
  }
})

/**
 * ログイン画面への遷移の場合は store のフラグを更新する
 */
router.afterEach((to, from) => {
  if (['Login', 'LoginACN'].includes(to.name)) {
    store.commit({ type: 'initializeState' })
    store.dispatch({
      type: 'set',
      states: { 'loggedIn': false }
    })
  }
})

export default router
